'use strict';
import React, { Component } from 'react';
import TableRow from './TableRow.jsx';

class TableBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.data
        };
    }

    componentWillReceiveProps(nextProps) {
        this.state.data = nextProps.data;
    }

    render() {
        let productsRowTableNodes;
        let _newList = this.props.data;
        let me = this;
        if (this.props.data != undefined && this.props.data != "") {

            productsRowTableNodes = this.props.data.get_all_products_filter.map(row => {
                let _estado;
                let _checked;
                let _currentUser;

                if (row.Activo == true && row.Bloqueado == false) {
                    _estado = 0;
                }
                if (row.Activo == false && row.Bloqueado == true) {
                    _estado = 1
                }
                if (row.Activo == false && row.Bloqueado == false) {
                    _estado = 2
                }

                _checked = (_newList.checks.indexOf(row.Id) != -1);

                if (row.Id == _newList.current_user) {
                    _currentUser = true;
                }
                else {
                    _currentUser = false;
                }

                return (
                    <TableRow ID={row.Id}
                        nombre={row.Descripcion}
                        administradora={row.AdministradoraDescrip}
                        tipo={row.TipoProductoDescripcion}
                        isChecked={_checked}
                        deletedProducts={me.props.data.deleteProducts}
                        clickCheckbox={me.props.clickCheckbox}
                        tipoCuenta={row.TipoEmpresa}
                        routeToEditarProducto={this.props.routeToEditarProducto} />
                );
            });
        }
        return (

            <tbody>
                {productsRowTableNodes}
            </tbody>

        );
    }
}

export default TableBody